module.exports = __webpack_public_path__ + "static/media/expend2.655dcb4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/expend2.mp4
// module id = gV1J
// module chunks = 0